/**
 * Alert Type Constants
 *
 * Defines the available alert types corresponding to Alert.scss styles
 */
export const ALERT_TYPES = {
  WARNING: 'warning',
  DANGER: 'danger',
  SUCCESS: 'success',
  INFO: 'info'
}
